import React from 'react'
import { Link } from 'react-router-dom'
import type { FollowListRow } from '../../api/people'

type Props = {
  row: FollowListRow
  isSelf: boolean
  busy?: boolean
  onToggleFollow?: (nextIsFollowing: boolean) => void
}

export default function FollowUserRow({ row, isSelf, busy, onToggleFollow }: Props) {
  const handleLabel = row.handle ? `@${row.handle}` : ''
  const showCreator = row.is_creator
  const showSubscribed = row.is_subscribed
  const showMutual = row.is_mutual
  const isFollowing = row.is_followed_by_viewer
  const buttonLabel = isSelf ? 'You' : isFollowing ? 'Following' : 'Follow'

  return (
    <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-4 shadow-sm">
      <Link to={`/people/i/${row.public_id}`} className="shrink-0">
        {row.avatar_url ? (
          <img
            src={row.avatar_url}
            alt={row.display_name || row.handle || 'User'}
            className="h-12 w-12 rounded-full object-cover"
          />
        ) : (
          <div className="h-12 w-12 rounded-full bg-white/10" />
        )}
      </Link>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <Link to={`/people/i/${row.public_id}`} className="truncate font-semibold text-white hover:underline">
            {row.display_name || row.handle || 'User'}
          </Link>
          {handleLabel && <span className="text-xs text-white/60">{handleLabel}</span>}
        </div>
        <div className="mt-1 line-clamp-2 text-sm text-white/70">
          {row.bio || '—'}
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-white/70">
          {showCreator && <span className="rounded-full border border-white/15 bg-white/10 px-2 py-0.5">Creator</span>}
          {showSubscribed && <span className="rounded-full border border-white/15 bg-white/10 px-2 py-0.5">Subscribed</span>}
          {showMutual && <span className="rounded-full border border-white/15 bg-white/10 px-2 py-0.5">Mutual</span>}
          <span className="text-white/50">
            {row.followers_count} followers • {row.following_count} following
          </span>
        </div>
      </div>
      <button
        type="button"
        className={`shrink-0 rounded-full px-4 py-2 text-sm font-semibold transition ${
          isSelf
            ? 'border border-white/10 text-white/40'
            : isFollowing
              ? 'border border-white/15 text-white hover:bg-white/10'
              : 'bg-brand text-white hover:bg-brand-600'
        }`}
        disabled={isSelf || busy}
        onClick={() => onToggleFollow?.(!isFollowing)}
      >
        {busy ? 'Working…' : buttonLabel}
      </button>
    </div>
  )
}
